/**
 * Crea el arreglo que va a registrar las apuestas dentro de la alfombra
 * @param {*} scene - Escena actual de Phaser
 */
export function crearPosicionesUltimaApuesta(scene) {
  //[0]: Característica de la posición, [1]: Monto apostado total, [2]: Array de montos apostados, [3]: Imagen de la ficha en la alfombra, [4]: Descripcion de la posicion, [5]: Ganancia de la posicion, [6]:ID de la posición
  const ultimaApuesta = [
    // Números
    ["Verde", 0, [], null, "Número 0", 0, 0], // 0
    ["Rojo", 0, [], null, "Número 1", 0, 1], // 1
    ["Negro", 0, [], null, "Número 2", 0, 2], // 2
    ["Rojo", 0, [], null, "Número 3", 0, 3], // 3
    ["Negro", 0, [], null, "Número 4", 0, 4], // 4
    ["Rojo", 0, [], null, "Número 5", 0, 5], // 5
    ["Negro", 0, [], null, "Número 6", 0, 6], // 6
    ["Rojo", 0, [], null, "Número 7", 0, 7], // 7
    ["Negro", 0, [], null, "Número 8", 0, 8], // 8
    ["Rojo", 0, [], null, "Número 9", 0, 9], // 9
    ["Negro", 0, [], null, "Número 10", 0, 10], // 10
    ["Negro", 0, [], null, "Número 11", 0, 11], // 11
    ["Rojo", 0, [], null, "Número 12", 0, 12], // 12
    ["Negro", 0, [], null, "Número 13", 0, 13], // 13
    ["Rojo", 0, [], null, "Número 14", 0, 14], // 14
    ["Negro", 0, [], null, "Número 15", 0, 15], // 15
    ["Rojo", 0, [], null, "Número 16", 0, 16], // 16
    ["Negro", 0, [], null, "Número 17", 0, 17], // 17
    ["Rojo", 0, [], null, "Número 18", 0, 18], // 18
    ["Rojo", 0, [], null, "Número 19", 0, 19], // 19
    ["Negro", 0, [], null, "Número 20", 0, 20], // 20
    ["Rojo", 0, [], null, "Número 21", 0, 21], // 21
    ["Negro", 0, [], null, "Número 22", 0, 22], // 22
    ["Rojo", 0, [], null, "Número 23", 0, 23], // 23
    ["Negro", 0, [], null, "Número 24", 0, 24], // 24
    ["Rojo", 0, [], null, "Número 25", 0, 25], // 25
    ["Negro", 0, [], null, "Número 26", 0, 26], // 26
    ["Rojo", 0, [], null, "Número 27", 0, 27], // 27
    ["Negro", 0, [], null, "Número 28", 0, 28], // 28
    ["Negro", 0, [], null, "Número 29", 0, 29], // 29
    ["Rojo", 0, [], null, "Número 30", 0, 30], // 30
    ["Negro", 0, [], null, "Número 31", 0, 31], // 31
    ["Rojo", 0, [], null, "Número 32", 0, 32], // 32
    ["Negro", 0, [], null, "Número 33", 0, 33], // 33
    ["Rojo", 0, [], null, "Número 34", 0, 34], // 34
    ["Negro", 0, [], null, "Número 35", 0, 35], // 35
    ["Rojo", 0, [], null, "Número 36", 0, 36],  // 36
    // Chances
    ["Chances", 0, [], null, "Chances 1-12", 0, 37], // 37
    ["Chances", 0, [], null, "Chances 13-24", 0, 38], // 38
    ["Chances", 0, [], null, "Chances 25-36", 0, 39], // 39
    ["Chances", 0, [], null, "Fila 1", 0, 40], // 40
    ["Chances", 0, [], null, "Fila 2", 0, 41], // 41
    ["Chances", 0, [], null, "Fila 3", 0, 42], // 42
    ["Chances", 0, [], null, "1-18", 0, 43], // 43
    ["Chances", 0, [], null, "Par", 0, 44], // 44
    ["Chances", 0, [], null, "Rojo", 0, 45], // 45
    ["Chances", 0, [], null, "Negro", 0, 46], // 46
    ["Chances", 0, [], null, "Impar", 0, 47], // 47
    ["Chances", 0, [], null, "19-36", 0, 48], // 48
    // Sexta Linea
    ["[1], [2], [3], [4], [5], [6]", 0, [], null, "Sexta linea 1, 2, 3, 4, 5, 6", 0, 49], // 49
    ["[4], [5], [6], [7], [8], [9]", 0, [], null, "Sexta linea 4, 5, 6, 7, 8, 9", 0, 50], // 50
    ["[7], [8], [9], [10], [11], [12]", 0, [], null, "Sexta linea 7, 8, 9, 10, 11, 12", 0, 51], // 51
    ["[10], [11], [12], [13], [14], [15]", 0, [], null, "Sexta linea 10, 11, 12, 13, 14, 15", 0, 52], // 52
    ["[13], [14], [15], [16], [17], [18]", 0, [], null, "Sexta linea 13, 14, 15, 16, 17, 18", 0, 53], // 53
    ["[16], [17], [18], [19], [20], [21]", 0, [], null, "Sexta linea 16, 17, 18, 19, 20, 21", 0, 54], // 54
    ["[19], [20], [21], [22], [23], [24]", 0, [], null, "Sexta linea 19, 20, 21, 22, 23, 24", 0, 55], // 55
    ["[22], [23], [24], [25], [26], [27]", 0, [], null, "Sexta linea 22, 23, 24, 25, 26, 27", 0, 56], // 56
    ["[25], [26], [27], [28], [29], [30]", 0, [], null, "Sexta linea 25, 26, 27, 28, 29, 30", 0, 57], // 57
    ["[28], [29], [30], [31], [32], [33]", 0, [], null, "Sexta linea 28, 29, 30, 31, 32, 33", 0, 58], // 58
    ["[31], [32], [33], [34], [35], [36]", 0, [], null, "Sexta linea 31, 32, 33, 34, 35, 36", 0, 59], // 59
    // Calle
    ["[0], [2], [3]", 0, [], null, "Calle 0, 2, 3", 0, 60], // 60
    ["[0], [1], [2]", 0, [], null, "Calle 0, 1, 2", 0, 61], // 61
    ["[1], [2], [3]", 0, [], null, "Calle 1, 2, 3", 0, 62], // 62
    ["[4], [5], [6]", 0, [], null, "Calle 4, 5, 6", 0, 63], // 63
    ["[7], [8], [9]", 0, [], null, "Calle 7, 8, 9", 0, 64], // 64
    ["[10], [11], [12]", 0, [], null, "Calle 10, 11, 12", 0, 65], // 65
    ["[13], [14], [15]", 0, [], null, "Calle 13, 14, 15", 0, 66], // 66
    ["[16], [17], [18]", 0, [], null, "Calle 16, 17, 18", 0, 67], // 67
    ["[19], [20], [21]", 0, [], null, "Calle 19, 20, 21", 0, 68], // 68
    ["[22], [23], [24]", 0, [], null, "Calle 22, 23, 24", 0, 69], // 69
    ["[25], [26], [27]", 0, [], null, "Calle 25, 26, 27", 0, 70], // 70
    ["[28], [29], [30]", 0, [], null, "Calle 28, 29, 30", 0, 71], // 71
    ["[31], [32], [33]", 0, [], null, "Calle 31, 32, 33", 0, 72], // 72
    ["[34], [35], [36]", 0, [], null, "Calle 34, 35, 36", 0, 73], // 73
    // Esquina Superior + 0
    ["[0], [1], [2], [3]", 0, [], null, "Esquina 0, 1, 2, 3", 0, 74], // 74
    ["[3], [6], [2], [5]", 0, [], null, "Esquina 3, 6, 2, 5", 0, 75], // 75
    ["[6], [9], [5], [8]", 0, [], null, "Esquina 6, 9, 5, 8", 0, 76], // 76
    ["[9], [12], [8], [11]", 0, [], null, "Esquina 9, 12, 8, 11", 0, 77], // 77
    ["[12], [15], [11], [14]", 0, [], null, "Esquina 12, 15, 11, 14", 0, 78], // 78
    ["[15], [18], [14], [17]", 0, [], null, "Esquina 15, 18, 14, 17", 0, 79], // 79
    ["[18], [21], [17], [20]", 0, [], null, "Esquina 18, 21, 17, 20", 0, 80], // 80
    ["[21], [24], [20], [23]", 0, [], null, "Esquina 21, 24, 20, 23", 0, 81], // 81
    ["[24], [27], [23], [26]", 0, [], null, "Esquina 24, 27, 23, 26", 0, 82], // 82
    ["[27], [30], [26], [29]", 0, [], null, "Esquina 27, 30, 26, 29", 0, 83], // 83
    ["[30], [33], [29], [32]", 0, [], null, "Esquina 30, 33, 29, 32", 0, 84], // 84
    ["[33], [36], [32], [35]", 0, [], null, "Esquina 33, 36, 32, 35", 0, 85], // 85
    // Esquina Inferior
    ["[2], [5], [1], [4]", 0, [], null, "Esquina 2, 5, 1, 4", 0, 86], // 86
    ["[5], [8], [4], [7]", 0, [], null, "Esquina 5, 8, 4, 7", 0, 87], // 87
    ["[8], [11], [7], [10]", 0, [], null, "Esquina 8, 11, 7, 10", 0, 88], // 88
    ["[11], [14], [10], [13]", 0, [], null, "Esquina 11, 14, 10, 13", 0, 89], // 89
    ["[14], [17], [13], [16]", 0, [], null, "Esquina 14, 17, 13, 16", 0, 90], // 90
    ["[17], [20], [16], [19]", 0, [], null, "Esquina 17, 20, 16, 19", 0, 91], // 91
    ["[20], [23], [19], [22]", 0, [], null, "Esquina 20, 23, 19, 22", 0, 92], // 92
    ["[23], [26], [22], [25]", 0, [], null, "Esquina 23, 26, 22, 25", 0, 93], // 93
    ["[26], [29], [25], [28]", 0, [], null, "Esquina 26, 29, 25, 28", 0, 94], // 94
    ["[29], [32], [28], [31]", 0, [], null, "Esquina 29, 32, 28, 31", 0, 95], // 95
    ["[32], [35], [31], [34]", 0, [], null, "Esquina 32, 35, 31, 34", 0, 96], // 96
    // Dobles Horizontal Fila Superior
    ["[0], [3]", 0, [], null, "Dobles horizontal 0, 3", 0, 97], // 97
    ["[3], [6]", 0, [], null, "Dobles horizontal 3, 6", 0, 98], // 98
    ["[6], [9]", 0, [], null, "Dobles horizontal 6, 9", 0, 99], // 99
    ["[9], [12]", 0, [], null, "Dobles horizontal 9, 12", 0, 100], // 100
    ["[12], [15]", 0, [], null, "Dobles horizontal 12, 15", 0, 101], // 101
    ["[15], [18]", 0, [], null, "Dobles horizontal 15, 18", 0, 102], // 102
    ["[18], [21]", 0, [], null, "Dobles horizontal 18, 21", 0, 103], // 103
    ["[21], [24]", 0, [], null, "Dobles horizontal 21, 24", 0, 104], // 104
    ["[24], [27]", 0, [], null, "Dobles horizontal 24, 27", 0, 105], // 105
    ["[27], [30]", 0, [], null, "Dobles horizontal 27, 30", 0, 106], // 106
    ["[30], [33]", 0, [], null, "Dobles horizontal 30, 33", 0, 107], // 107
    ["[33], [36]", 0, [], null, "Dobles horizontal 33, 36", 0, 108], // 108
    // Dobles Horizontal Fila Medio
    ["[0], [2]", 0, [], null, "Dobles horizontal 0, 2", 0, 109], // 109
    ["[2], [5]", 0, [], null, "Dobles horizontal 2, 5", 0, 110], // 110
    ["[5], [8]", 0, [], null, "Dobles horizontal 5, 8", 0, 111], // 111
    ["[8], [11]", 0, [], null, "Dobles horizontal 8, 11", 0, 112], // 112
    ["[11], [14]", 0, [], null, "Dobles horizontal 11, 14", 0, 113], // 113
    ["[14], [17]", 0, [], null, "Dobles horizontal 14, 17", 0, 114], // 114
    ["[17], [20]", 0, [], null, "Dobles horizontal 17, 20", 0, 115], // 115
    ["[20], [23]", 0, [], null, "Dobles horizontal 20, 23", 0, 116], // 116
    ["[23], [26]", 0, [], null, "Dobles horizontal 23, 26", 0, 117], // 117
    ["[26], [29]", 0, [], null, "Dobles horizontal 26, 29", 0, 118], // 118
    ["[29], [32]", 0, [], null, "Dobles horizontal 29, 32", 0, 119], // 119
    ["[32], [35]", 0, [], null, "Dobles horizontal 32, 35", 0, 120], // 120
    // Dobles Horizontal Fila Inferior
    ["[0], [1]", 0, [], null, "Dobles horizontal 0, 1", 0, 121], // 121
    ["[1], [4]", 0, [], null, "Dobles horizontal 1, 4", 0, 122], // 122
    ["[4], [7]", 0, [], null, "Dobles horizontal 4, 7", 0, 123], // 123
    ["[7], [10]", 0, [], null, "Dobles horizontal 7, 10", 0, 124], // 124
    ["[10], [13]", 0, [], null, "Dobles horizontal 10, 13", 0, 125], // 125
    ["[13], [16]", 0, [], null, "Dobles horizontal 13, 16", 0, 126], // 126
    ["[16], [19]", 0, [], null, "Dobles horizontal 16, 19", 0, 127], // 127
    ["[19], [22]", 0, [], null, "Dobles horizontal 19, 22", 0, 128], // 128
    ["[22], [25]", 0, [], null, "Dobles horizontal 22, 25", 0, 129], // 129
    ["[25], [28]", 0, [], null, "Dobles horizontal 25, 28", 0, 130], // 130
    ["[28], [31]", 0, [], null, "Dobles horizontal 28, 31", 0, 131], // 131
    ["[31], [34]", 0, [], null, "Dobles horizontal 31, 34", 0, 132], // 132
    // Dobles Vertical Fila Superior
    ["[3], [2]", 0, [], null, "Dobles vertical 3, 2", 0, 133], // 133
    ["[6], [5]", 0, [], null, "Dobles vertical 6, 5", 0, 134], // 134
    ["[9], [8]", 0, [], null, "Dobles vertical 9, 8", 0, 135], // 135
    ["[12], [11]", 0, [], null, "Dobles vertical 12, 11", 0, 136], // 136
    ["[15], [14]", 0, [], null, "Dobles vertical 15, 14", 0, 137], // 137
    ["[18], [17]", 0, [], null, "Dobles vertical 18, 17", 0, 138], // 138
    ["[21], [20]", 0, [], null, "Dobles vertical 21, 20", 0, 139], // 139
    ["[24], [23]", 0, [], null, "Dobles vertical 24, 23", 0, 140], // 140
    ["[27], [26]", 0, [], null, "Dobles vertical 27, 26", 0, 141], // 141
    ["[30], [29]", 0, [], null, "Dobles vertical 30, 29", 0, 142], // 142
    ["[33], [32]", 0, [], null, "Dobles vertical 33, 32", 0, 143], // 143
    ["[36], [35]", 0, [], null, "Dobles vertical 36, 35", 0, 144], // 144
    // Dobles Vertical Fila Inferior
    ["[2], [1]", 0, [], null, "Dobles vertical 2, 1", 0, 145], // 145
    ["[5], [4]", 0, [], null, "Dobles vertical 5, 4", 0, 146], // 146
    ["[8], [7]", 0, [], null, "Dobles vertical 8, 7", 0, 147], // 147
    ["[11], [10]", 0, [], null, "Dobles vertical 11, 10", 0, 148], // 148
    ["[14], [13]", 0, [], null, "Dobles vertical 14, 13", 0, 149], // 149
    ["[17], [16]", 0, [], null, "Dobles vertical 17, 16", 0, 150], // 150
    ["[20], [19]", 0, [], null, "Dobles vertical 20, 19", 0, 151], // 151
    ["[23], [22]", 0, [], null, "Dobles vertical 23, 22", 0, 152], // 152
    ["[26], [25]", 0, [], null, "Dobles vertical 26, 25", 0, 153], // 153
    ["[29], [28]", 0, [], null, "Dobles vertical 29, 28", 0, 154], // 154
    ["[32], [31]", 0, [], null, "Dobles vertical 32, 31", 0, 155], // 155
    ["[35], [34]", 0, [], null, "Dobles vertical 35, 34", 0, 156] // 156
  ];

  scene.posicionesUltimaApuesta = ultimaApuesta;
}
